import authApi from '../../../services/auth.axios';
import otpApi from '../../../services/otp.axios';
import AuthError from '../domain/AuthError';
import OrderNotFoundError from '../domain/OrderNotFoundError';
import {
  buildAuthError,
  mapLoginApiError,
  mapOtpApiError,
} from '../application/authErrorMapper';

async function loginWithoutIdk({ email, orderHigherIdExt, brand }) {
  try {
    const { data } = await authApi.post('/login', {
      email,
      orderHigherIdExt,
      brand,
    });

    return data.data;
  } catch (error) {
    if (error instanceof OrderNotFoundError || error instanceof AuthError) {
      throw error;
    }
    throw mapLoginApiError(error?.response?.data);
  }
}

async function requestOtp({
  email,
  orderHigherIdExt,
  channel,
  phone,
  challengeId,
}) {
  try {
    const { data } = await otpApi.post('request-otp', {
      email,
      orderId: orderHigherIdExt,
      channel,
      phone,
      challengeId,
    });

    if (!data.success) {
      throw mapOtpApiError(data);
    }

    return data.data;
  } catch (error) {
    if (error instanceof OrderNotFoundError || error instanceof AuthError) {
      throw error;
    }

    throw buildAuthError(error);
  }
}

async function verifyOtp({
  email,
  orderHigherIdExt,
  challengeId,
  otp,
}) {
  try {
    const { data } = await otpApi.post('verify-otp', {
      email,
      orderId: orderHigherIdExt,
      challengeId,
      otp,
    });

    if (!data.success) {
      throw mapOtpApiError(data);
    }

    return data.data;
  } catch (error) {
    if (error instanceof OrderNotFoundError || error instanceof AuthError) {
      throw error;
    }

    throw buildAuthError(error);
  }
}

export default function createAuthApiRepository() {
  return {
    loginWithoutIdk,
    requestOtp,
    verifyOtp,
  };
}
